import { Component, Input } from "@angular/core";

@Component({
    selector: "app-driveb-page-heading",
    templateUrl: "./page-heading.component.html",
    styleUrls: ["./page-heading.component.scss"],
    standalone: false
})
export class PageHeadingComponent {
  @Input() pageTitle = "";
}
